export default __webpack_public_path__ + "static/media/comin-soon-email-1.126ea0c6.jpeg";